import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight/companies',
}).lazy(() => import('./companies.lazy').then((d) => d.Route))
